import { Chip, Typography } from '@mui/material';
import {
  FilterOperator,
  FilterValue,
} from 'src/hooks/meilisearch/types/filter-value';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { Filters } from 'src/types/interfaces/filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';

interface Props {
  filterValue: FilterValue;
  filterType: string;
  filterOperator: FilterOperator | undefined;
  text: string;
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const FilterChip = ({
  filterValue,
  filterType,
  filterOperator,
  text,
  filters,
  handleChangeFilterValue,
}: Props) => {
  const handleDeleteFilter = () => {
    if (filterOperator === 'timerange') {
      handleChangeFilterValue(filterType, [], filterOperator);

      return;
    }

    if (typeof filterValue === 'string') {
      toggleFilterItemSelection(
        filterType,
        filterValue,
        false,
        filters,
        handleChangeFilterValue,
        filterOperator,
      );
    }
  };

  return (
    <Chip
      sx={{ mr: 1, mb: 1 }}
      color="primary"
      label={
        <Typography variant="caption" sx={{ textTransform: 'capitalize' }}>
          {text}
        </Typography>
      }
      size="small"
      onDelete={handleDeleteFilter}
    />
  );
};
